export default __webpack_public_path__ + "static/media/argentan12.d352e85a.jpg";